<template>
  <div class="home">
    <div class="centered-home">
      <h1>Découvrez les méthodes de<br>L'UX Design</h1>
      <div class="content">
        <section>
          <p>
            Apprendre les méthodes et les outils de l’UX Design en ligne devient fun et facile !
            Vous pouvez maintenant apprendre les fondamentaux rapidement et où que vous soyez ! Nos équipes ont réunie des années de savoir en explications simples et ludiques à portée de tous.
          </p>
          <div class="start-box">
            <a href="#entretiens"><button>COMMENCER</button></a>
            <ul>
              <li><a href="#entretiens">Recherche</a></li>
              <li><a href="#brainstorming">Idéation</a></li>
              <li><a href="#design_persuasif">Création</a></li>
              <li><a href="#echelles_utilisabilites">Tester</a></li>
            </ul>
          </div>
        </section>
        <aside>
          <svg
            id="methodeux"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 691.764 618.914"
          >
            <ellipse
              id="Ellipse_57"
              data-name="Ellipse 57"
              cx="345.882"
              cy="42.552"
              rx="345.882"
              ry="42.552"
              transform="translate(0 533.809)"
              fill="#3f3d56"
            />
            <path
              id="Tracé_343"
              data-name="Tracé 343"
              d="M331.639,455.064V653.38L196.566,676.023,49,658.065v-199.1L196.566,445.7Z"
              transform="translate(-10.742 -97.709)"
              fill="#3f3d56"
            />
            <path
              id="Tracé_344"
              data-name="Tracé 344"
              d="M196.566,469.722V679.75L49,661.792V462.7Z"
              transform="translate(-10.742 -101.436)"
              opacity="0.1"
            />
            <path
              id="Tracé_345"
              data-name="Tracé 345"
              d="M331.639,455.064,196.566,466,49,458.968,196.566,445.7Z"
              transform="translate(-10.742 -97.709)"
              fill="#fff"
              opacity="0.1"
            />
            <path
              id="Tracé_346"
              data-name="Tracé 346"
              d="M708.2,628.53V702.7l-94.473,21.081L424,708.168V641.8l3.107-.523.289-.047L591.085,613.7l115.109,14.577Z"
              transform="translate(-92.953 -134.539)"
              fill="#d0cde1"
            />
            <path
              id="Tracé_347"
              data-name="Tracé 347"
              d="M613.727,660.479v71.05L424,715.914V649.548l3.107-.523Z"
              transform="translate(-92.953 -142.285)"
              opacity="0.1"
            />
            <path
              id="Tracé_348"
              data-name="Tracé 348"
              d="M707.148,628.272l-92.467,24.462-186.331-11.5L592.039,613.7Z"
              transform="translate(-93.906 -134.539)"
              fill="#fff"
              opacity="0.1"
            />
            <path
              id="Tracé_349"
              data-name="Tracé 349"
              d="M502,607.347V759.6a207.378,207.378,0,0,0,103.062,0V607.347Z"
              transform="translate(-232.634 -175.038)"
              fill="#decab0"
            />
            <ellipse
              id="Ellipse_58"
              data-name="Ellipse 58"
              cx="51.531"
              cy="5.856"
              rx="51.531"
              ry="5.856"
              transform="translate(269.366 425.282)"
              fill="#decab0"
            />
            <ellipse
              id="Ellipse_59"
              data-name="Ellipse 59"
              cx="51.531"
              cy="5.856"
              rx="51.531"
              ry="5.856"
              transform="translate(269.366 425.282)"
              opacity="0.1"
            />
            <path
              id="Tracé_350"
              data-name="Tracé 350"
              d="M633.41,338.028c.7,1.626,1.437,3.271,2.2,4.886l-1.625.763c-.767-1.634-1.513-3.3-2.219-4.941Z"
              transform="translate(-261.081 -115.996)"
              fill="#e6e6e6"
            />
            <path
              id="Tracé_351"
              data-name="Tracé 351"
              d="M919.615,145.567c1.025,2.185,2.01,4.41,2.927,6.617l-1.658.689c-1.373-3.3-2.892-6.632-4.494-9.852l1.608-.8Q918.823,143.88,919.615,145.567Zm-6.823-12.979-1.55.907c-1.819-3.109-3.765-6.187-5.784-9.151l1.484-1.01C908.984,126.332,910.952,129.445,912.792,132.588Zm13.611,29.84c1.167,3.45,2.227,6.977,3.151,10.486l-1.736.456c-.914-3.468-1.962-6.955-3.116-10.366ZM900.472,114.5l-1.412,1.11c-2.222-2.824-4.572-5.607-6.984-8.271l1.33-1.205c2.44,2.695,4.818,5.51,7.066,8.366Zm31.505,69.09c.681,3.569,1.247,7.21,1.681,10.82l-1.782.215c-.43-3.571-.989-7.17-1.662-10.7Zm-46.2-85.314-1.244,1.295c-2.59-2.49-5.3-4.921-8.049-7.223l1.153-1.376C880.421,93.3,883.16,95.76,885.78,98.279Zm48.81,107.061c.183,3.64.242,7.328.173,10.962l-1.8-.034c.068-3.593.01-7.239-.171-10.838Zm-65.574-121.1L867.96,85.7c-2.908-2.111-5.925-4.149-8.967-6.055l.953-1.522C863.023,80.047,866.074,82.107,869.016,84.243Zm65.167,143c-.318,3.628-.765,7.287-1.33,10.877l-1.773-.279c.558-3.548,1-7.167,1.315-10.755Zm-83.7-154.617-.847,1.583c-3.169-1.7-6.437-3.3-9.713-4.779l.736-1.637C843.968,69.287,847.273,70.913,850.478,72.629Zm80.3,176.252c-.808,3.543-1.75,7.106-2.8,10.59l-1.719-.518c1.036-3.445,1.967-6.968,2.767-10.471ZM830.523,63.642l-.624,1.683c-3.371-1.249-6.828-2.4-10.277-3.416l.509-1.722C823.618,61.216,827.114,62.378,830.523,63.642Zm93.947,206.2c-1.284,3.4-2.7,6.8-4.211,10.108l-1.632-.746c1.494-3.267,2.894-6.63,4.163-9.995ZM809.524,57.449l-.39,1.752c-3.506-.779-7.089-1.448-10.648-1.987l.269-1.774C802.354,55.983,805.978,56.66,809.524,57.449Zm105.847,232.3c-1.733,3.2-3.6,6.371-5.544,9.437l-1.516-.962c1.924-3.032,3.769-6.171,5.483-9.332ZM787.87,54.171l-.146,1.788c-3.587-.294-7.228-.466-10.825-.512l.023-1.795C780.559,53.7,784.242,53.873,787.87,54.171ZM903.651,308.218c-2.152,2.927-4.433,5.816-6.779,8.587l-1.37-1.16c2.319-2.74,4.575-5.6,6.7-8.49ZM765.962,53.888l.1,1.792c-3.594.2-7.227.533-10.8.982l-.224-1.781C758.653,54.426,762.328,54.092,765.962,53.888ZM889.522,324.9c-2.535,2.607-5.194,5.158-7.9,7.582l-1.2-1.338c2.677-2.4,5.3-4.918,7.812-7.5ZM744.228,56.625l.347,1.762c-3.528.694-7.075,1.521-10.544,2.455l-.467-1.733C737.073,58.164,740.66,57.328,744.228,56.625ZM873.215,339.5c-2.869,2.231-5.853,4.392-8.869,6.421l-1-1.49c2.982-2.006,5.933-4.142,8.768-6.349ZM723.1,62.319l.584,1.7c-3.393,1.169-6.794,2.473-10.109,3.874l-.7-1.653C716.226,64.82,719.666,63.5,723.1,62.319Zm131.96,289.4c-3.143,1.815-6.393,3.548-9.661,5.152l-.79-1.612c3.232-1.585,6.446-3.3,9.554-5.094ZM703.747,72.442c-3.213,1.62-6.408,3.37-9.5,5.2l-.915-1.544c3.123-1.851,6.354-3.62,9.6-5.259ZM685.132,83.477c-2.963,2.044-5.889,4.214-8.7,6.449l-1.118-1.4c2.839-2.261,5.8-4.455,8.8-6.523ZM668.205,96.959c-2.648,2.426-5.244,4.974-7.718,7.575l-1.3-1.237c2.5-2.63,5.128-5.208,7.806-7.661Zm-14.9,15.666c-2.292,2.77-4.515,5.653-6.607,8.568l-1.459-1.047c2.116-2.948,4.365-5.864,6.683-8.666ZM640.7,130.2c-1.893,3.06-3.7,6.222-5.377,9.394l-1.587-.837c1.693-3.209,3.523-6.406,5.437-9.5Zm-10.1,19.136c-1.458,3.285-2.821,6.663-4.052,10.041l-1.687-.614c1.245-3.417,2.623-6.833,4.1-10.155Zm-7.409,20.337c-1,3.459-1.89,6.992-2.649,10.5l-1.754-.379c.768-3.55,1.669-7.124,2.679-10.621Zm-4.577,21.161c-.518,3.564-.919,7.187-1.192,10.768l-1.79-.136c.276-3.622.682-7.286,1.206-10.891Zm-1.642,21.6c-.026,3.6.073,7.244.3,10.833l-1.792.111c-.225-3.629-.325-7.316-.3-10.957Zm1.339,21.622c.469,3.564,1.07,7.156,1.784,10.679l-1.759.357c-.722-3.563-1.329-7.2-1.8-10.8Zm4.3,21.21c.955,3.462,2.043,6.938,3.234,10.332l-1.695.594c-1.2-3.433-2.3-6.949-3.27-10.449Z"
              transform="translate(-257.443 -53.653)"
              fill="#e6e6e6"
            />
            <path
              id="Tracé_352"
              data-name="Tracé 352"
              d="M894.664,445.759l.677,1.662c-1.678.684-3.377,1.343-5.049,1.959l-.621-1.684C891.325,447.088,893,446.436,894.664,445.759Z"
              transform="translate(-317.622 -139.614)"
              fill="#e6e6e6"
            />
            <circle
              id="Ellipse_60"
              data-name="Ellipse 60"
              cx="33.573"
              cy="33.573"
              r="33.573"
              transform="translate(287.324 327.686)"
              fill="#decab0"
            />
            <path
              id="Tracé_353"
              data-name="Tracé 353"
              d="M223.879,584.332h32.249a112.791,112.791,0,0,0,0-38.45H223.879A69.186,69.186,0,0,1,223.879,584.332Z"
              transform="translate(-171.662 -161.563)"
              fill="#decab0"
            />
            <path
              id="Tracé_354"
              data-name="Tracé 354"
              d="M312.6,636.354H280.354a112.792,112.792,0,0,1,0-38.45H312.6A69.185,69.185,0,0,0,312.6,636.354Z"
              transform="translate(-183.681 -172.968)"
              fill="#ff6584"
            />
            <path
              id="Tracé_355"
              data-name="Tracé 355"
              d="M300.879,716.332h32.249a112.791,112.791,0,0,0,0-38.45H300.879A69.186,69.186,0,0,1,300.879,716.332Z"
              transform="translate(-188.542 -190.501)"
              fill="#decab0"
            />
            <path
              id="Tracé_356"
              data-name="Tracé 356"
              d="M362.41,394.941a92.241,92.241,0,1,0-42.8,34.363,29.837,29.837,0,1,0,42.8-34.363Z"
              transform="translate(-165.03 -96.963)"
              fill="#decab0"
            />
            <rect
              id="Rectangle_43"
              data-name="Rectangle 43"
              width="109.726"
              height="8.663"
              transform="translate(65.887 228.043)"
              fill="#fff"
            />
            <rect
              id="Rectangle_44"
              data-name="Rectangle 44"
              width="109.726"
              height="8.663"
              transform="translate(65.887 242.481)"
              fill="#fff"
            />
            <rect
              id="Rectangle_45"
              data-name="Rectangle 45"
              width="109.726"
              height="8.663"
              transform="translate(65.887 256.918)"
              fill="#fff"
            />
            <path
              id="Tracé_357"
              data-name="Tracé 357"
              d="M900.365,631.96c-.179-.293-4.4-7.347-5.869-22-1.344-13.439-.48-36.092,11.269-67.692,22.257-59.862-5.129-108.163-5.409-108.644l1.351-.784c.071.122,7.137,12.437,11.312,32.046a139.8,139.8,0,0,1-5.79,77.926c-22.219,59.76-5.7,88.05-5.531,88.329Z"
              transform="translate(-318.576 -136.782)"
              fill="#3f3d56"
            />
            <circle
              id="Ellipse_61"
              data-name="Ellipse 61"
              cx="10.15"
              cy="10.15"
              r="10.15"
              transform="translate(562.936 273.032)"
              fill="#decab0"
            />
            <circle
              id="Ellipse_62"
              data-name="Ellipse 62"
              cx="10.15"
              cy="10.15"
              r="10.15"
              transform="translate(594.948 310.509)"
              fill="#3f3d56"
            />
            <circle
              id="Ellipse_63"
              data-name="Ellipse 63"
              cx="10.15"
              cy="10.15"
              r="10.15"
              transform="translate(573.086 335.493)"
              fill="#decab0"
            />
            <circle
              id="Ellipse_64"
              data-name="Ellipse 64"
              cx="10.15"
              cy="10.15"
              r="10.15"
              transform="translate(599.633 356.574)"
              fill="#decab0"
            />
            <circle
              id="Ellipse_65"
              data-name="Ellipse 65"
              cx="10.15"
              cy="10.15"
              r="10.15"
              transform="translate(565.279 389.367)"
              fill="#3f3d56"
            />
            <path
              id="Tracé_358"
              data-name="Tracé 358"
              d="M909.544,676.07s-10.15-24.985,20.3-43.723Z"
              transform="translate(-321.623 -180.519)"
              fill="#3f3d56"
            />
            <path
              id="Tracé_359"
              data-name="Tracé 359"
              d="M882.676,680.37S878.057,653.8,842.3,654.029Z"
              transform="translate(-307.238 -185.272)"
              fill="#3f3d56"
            />
            <circle
              id="Ellipse_66"
              data-name="Ellipse 66"
              cx="34.085"
              cy="34.085"
              r="34.085"
              transform="translate(479.231 104.73)"
              fill="#2f2e41"
            />
            <path
              id="Tracé_360"
              data-name="Tracé 360"
              d="M743.057,315.678l-9.5,21.539-10.136-30.407s-1.267-26.606-10.136-25.339-1.267,26.606-1.267,26.606,5.7,56.38,18.371,53.213,20.905-21.539,20.905-21.539l2.217-19.424Z"
              transform="translate(-278.011 -103.587)"
              fill="#a0616a"
            />
            <path
              id="Tracé_361"
              data-name="Tracé 361"
              d="M796.1,261.8s3.8,20.905-4.434,25.339,31.674,3.167,32.308-3.8c0,0-8.869-21.539-8.869-26.606Z"
              transform="translate(-295.891 -98.174)"
              fill="#a0616a"
            />
            <path
              id="Tracé_362"
              data-name="Tracé 362"
              d="M720.576,483.1s3.167,36.109,4.434,43.711,1.267,19,1.267,19-3.167,24.706-1.9,48.145l1.9,19.638h14.57l.556-2.614,5.779-27.16s6.335-22.172,3.8-38.643l6.968-53.213Z"
              transform="translate(-280.552 -147.801)"
              fill="#a0616a"
            />
            <path
              id="Tracé_363"
              data-name="Tracé 363"
              d="M778.182,499.332s15.2,47.512,19,52.579,8.869,16.471,8.869,16.471,10.769,26.606,16.471,31.041l6.335,11.4,10.769-3.167-3.167-25.339a80.047,80.047,0,0,0-15.2-39.276L814.291,500.6Z"
              transform="translate(-293.181 -151.358)"
              fill="#a0616a"
            />
            <path
              id="Tracé_364"
              data-name="Tracé 364"
              d="M811.148,289.447s-18.755,4.9-25.848,2.767c0,0-7.093-.233-9.627.4s-18.371,6.335-18.371,7.6,3.167,13.937,3.167,13.937-1.9,7.6-1.267,12.67-11.4,20.905-5.068,22.172,10.136-1.267,13.3,1.267S808.614,364.2,808.614,364.2l31.674-62.715s-5.068-10.769-9.5-10.769-16.257-3.241-16.257-3.241Z"
              transform="translate(-287.504 -104.913)"
              fill="#3f3d56"
            />
            <path
              id="Tracé_365"
              data-name="Tracé 365"
              d="M759.525,304.25l-3.167-1.267s-11.4,17.738-7.6,19.638,13.3,6.335,13.3,6.335Z"
              transform="translate(-286.56 -108.313)"
              fill="#3f3d56"
            />
            <path
              id="Tracé_366"
              data-name="Tracé 366"
              d="M746.959,363.023l-10.136,16.471s-15.837,2.534-17.1,24.072c0,0-10.769,3.8-13.3,23.439,0,0-15.837,10.136-7.6,21.539s52.579,34.208,99.457,26.606c0,0,8.869-17.738,2.534-29.774,0,0,6.795-12.78-4.838-21.593,0,0,9.906-12.615-.23-26.551l.633-20.272Z"
              transform="translate(-275.261 -121.475)"
              fill="#2f2e41"
            />
            <path
              id="Tracé_367"
              data-name="Tracé 367"
              d="M737.981,647.81H720.243s-.633,15.837-7.6,19.638-20.272,24.073-10.136,26.606,39.91-16.471,39.91-20.905S737.981,647.81,737.981,647.81Z"
              transform="translate(-275.784 -183.909)"
              fill="#2f2e41"
            />
            <path
              id="Tracé_368"
              data-name="Tracé 368"
              d="M854.238,634.829l-15.2,5.7s11.4,31.041,11.4,35.475,1.9,9.5,13.3,7.6,9.5-10.769,9.5-10.769Z"
              transform="translate(-306.521 -181.063)"
              fill="#2f2e41"
            />
            <circle
              id="Ellipse_67"
              data-name="Ellipse 67"
              cx="19.638"
              cy="19.638"
              r="19.638"
              transform="translate(486.902 130.054)"
              fill="#a0616a"
            />
            <path
              id="Tracé_369"
              data-name="Tracé 369"
              d="M849.846,333s-8.869,31.674-10.136,34.208l-20.905,53.846s2.534,27.24-6.968,22.806-.633-27.873-.633-27.873l14.57-57.647L834.009,333Z"
              transform="translate(-299.596 -114.894)"
              fill="#a0616a"
            />
            <path
              id="Tracé_370"
              data-name="Tracé 370"
              d="M851.343,298.926l7.6,5.068s6.335,24.706,0,24.072-20.905,3.167-21.538,1.9S851.343,298.926,851.343,298.926Z"
              transform="translate(-306.16 -107.424)"
              fill="#3f3d56"
            />
            <circle
              id="Ellipse_68"
              data-name="Ellipse 68"
              cx="14.104"
              cy="14.104"
              r="14.104"
              transform="translate(509.798 89.001)"
              fill="#2f2e41"
            />
            <path
              id="Tracé_371"
              data-name="Tracé 371"
              d="M803.094,171.963a14.105,14.105,0,0,1,12.634-14.028,14.258,14.258,0,0,0-1.468-.076,14.1,14.1,0,0,0,0,28.208,14.261,14.261,0,0,0,1.469-.076A14.105,14.105,0,0,1,803.094,171.963Z"
              transform="translate(-297.998 -76.498)"
              fill="#2f2e41"
            />
            <ellipse
              id="Ellipse_69"
              data-name="Ellipse 69"
              cx="23.507"
              cy="14.104"
              rx="23.507"
              ry="14.104"
              transform="translate(484.107 113.592)"
              fill="#2f2e41"
            />
            <ellipse
              id="Ellipse_70"
              data-name="Ellipse 70"
              cx="1.584"
              cy="3.801"
              rx="1.584"
              ry="3.801"
              transform="translate(525.862 144.941)"
              fill="#a0616a"
            />
            <rect
              id="Rectangle_46"
              data-name="Rectangle 46"
              width="213.931"
              height="119.145"
              transform="translate(224.072 68.226)"
              fill="#3f3d56"
            />
            <rect
              id="Rectangle_47"
              data-name="Rectangle 47"
              width="134.809"
              height="3.952"
              transform="translate(263.376 113.822)"
              fill="#fff"
            />
            <rect
              id="Rectangle_48"
              data-name="Rectangle 48"
              width="134.809"
              height="3.952"
              transform="translate(263.376 129.628)"
              fill="#fff"
            />
            <rect
              id="Rectangle_49"
              data-name="Rectangle 49"
              width="134.809"
              height="3.952"
              transform="translate(263.376 145.434)"
              fill="#fff"
            />
            <rect
              id="Rectangle_50"
              data-name="Rectangle 50"
              width="213.931"
              height="13.273"
              transform="translate(224.072 68.355)"
              fill="#decab0"
            />
            <circle
              id="Ellipse_71"
              data-name="Ellipse 71"
              cx="4.835"
              cy="4.835"
              r="4.835"
              transform="translate(227.976 70.547)"
              fill="#e6e6e6"
            />
            <circle
              id="Ellipse_72"
              data-name="Ellipse 72"
              cx="4.835"
              cy="4.835"
              r="4.835"
              transform="translate(241.099 70.547)"
              fill="#e6e6e6"
            />
            <circle
              id="Ellipse_73"
              data-name="Ellipse 73"
              cx="4.835"
              cy="4.835"
              r="4.835"
              transform="translate(254.222 70.547)"
              fill="#e6e6e6"
            />
          </svg>
        </aside>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.home {
    display: flex;
    align-items: center;
    min-height: 100vh;
    max-width: 1300px;
    padding: 100px 40px;
    width: 100%;
    margin: 10px auto;
    overflow: hidden;
    
    .centered-home {
      width: 100%;
    }

    .content {
      display: flex;
      justify-content: center;
    }
    section {
        flex: 3;
    }

    h1 {
        width: 100%;
        white-space: nowrap;
        position: relative;
        font-family: "Montserrat", sans-serif;
        font-weight: 700;
        font-size: 2.6em;
    }

    p {
        font-family: "Lato", sans-serif;
        font-size: 1.2em;
        margin: 50px 0;
        margin-left: 10%;
        width: 100%;
        max-width: 400px;
    }

    .start-box {
        width: 100%;
        max-width: 50%;
        margin: 0 auto;
        button {
            display: block;
            font-family: "Montserrat";
            font-weight: 700;
            font-size: 2em;
            color: white;
            background-color: #3f3d56;
            width: 280px;
            height: 65px;
            border: none;
            margin: 0 auto;
            transition-duration: .2s;
            cursor: pointer;

            &:hover {
              background-color: #555275;
              transform: scale(0.97)
            }
        }
        ul {
            list-style-type: none;
            margin: 20px 0;
            padding: 0;
            display: flex;
            justify-content: space-between;
        }

        li {
            position: relative;
            display: block;
            margin: 0%;
            padding: 0%;
            font-family: "Lato", sans-serif;
            font-weight: 700;
            font-size: 0.9em;
            
            &:after {
                content: "";
                position: absolute;
                bottom: -4px;
                left: 0;right: 0;
                height: 2px;
                background-color: black;
            }
        }
    }

    ol:hover {
        border-bottom: 2px solid black;
    }

    .start {
        text-align: center;
        margin-top: 10vh;
    }


    aside {

        flex: 2;  
        svg {
            z-index: -1;
            transform: scale(1.2) translate(-40px, -80px);
            width: 450px;
        }
    }
    
    @media screen and (max-width: 1100px) {
        aside svg {
            transform: scale(0.8) translate(-40px,-100px);
        }
    }
}

@media screen and (max-width: 900px) { 

  .home {
    padding: 0 20px;
    margin: 40px 0;

    h1 {
      text-align: center;
      white-space: normal;
    }

    p {
      width: 100%;
      max-width: 450px;
      margin: 30px auto;
    }

    .start-box {
      max-width: 100%;
      width: 300px;
    }

    .content {
      display: flex;
      flex-direction: column;
      section {
        flex: 0;
        order: 2;
      }
      aside {
        flex: 1;
        order: 1;
        svg {
          display: block;
          width: 350px;
          max-width: 100%;
          margin: 0 auto;
          transform: none;
        }
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/components/home/Home.vue